function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.334 8.492h-8.103V.516a.46.46 0 00-.47-.515H9.088a.567.567 0 00-.6.515v7.976H.52A.567.567 0 000 9.087v1.67a.466.466 0 00.518.474h7.974v8.1a.71.71 0 00.6.666h1.67c.302 0 .472-.364.472-.666v-8.1h8.103c.301 0 .663-.172.663-.473V9.087a.701.701 0 00-.666-.595z",
  fillRule: "nonzero"
});

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgExpand;